import "./shared/IntakeForm.scss";

import ClientIntakeForm from "./ClientIntakeForm";
import IntakeHeader from "./components/HeaderIntake";
import { useOrganizationSlugValidation } from "./hooks/useOrganizationSlugValidation";

const DashboardIntake = () => {
  const { isValidating, isValid } = useOrganizationSlugValidation();

  // show loading while validating organization slug
  if (isValidating) {
    return (
      <div className="intake-form-page">
        <IntakeHeader />
        <div className="main-content intake-content">
          <h1 className="dashboard-title">Loading...</h1>
          <p>Validating organization...</p>
        </div>
      </div>
    );
  }

  // if slug validation failed, the hook will redirect to 404
  // but we also return early to prevent rendering
  if (isValid === false) {
    return null;
  }

  return (
    <div className="intake-form-page">
      <IntakeHeader />
      <ClientIntakeForm />
    </div>
  );
};

export default DashboardIntake;
